import { all } from 'redux-saga/effects';
import authSaga from '../auth/authSaga';
import insightSaga from '../insight/insightSaga';
import distributionSaga from '../distribution/distributionSaga';
import librarySaga from '../library/librarySaga';
import exploreSaga from '../explore/exploreSaga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    insightSaga(),
    distributionSaga(),
    librarySaga(),
    exploreSaga(),
  ]);
}
